var _circle, _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApprovingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_1_8)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9017 31.4301L21.3086 28.8369C20.5722 28.1004 19.3815 28.1004 18.6529 28.8369L16.0598 31.4301C15.2999 32.19 14.0622 32.19 13.3023 31.4301L12.0488 30.1766L16.0207 26.2045C18.2064 24.0187 21.7474 24.0187 23.933 26.2045L27.9049 30.1766L26.6515 31.4301C25.8994 32.19 24.6694 32.19 23.9017 31.4301Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82337 27.9432L8.56993 26.6897C7.81002 25.9298 7.81002 24.692 8.56993 23.932L11.163 21.3389C11.8994 20.6024 11.8994 19.4116 11.163 18.683L8.56993 16.0898C7.81002 15.3299 7.81002 14.0921 8.56993 13.3321L9.82337 12.0786L13.7952 16.0506C15.9809 18.2364 15.9809 21.7776 13.7952 23.9634L9.82337 27.9432Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0149 15.4329C18.5813 15.4329 17.1477 14.8923 16.0588 13.7955L12.0869 9.82345L13.3404 8.56995C14.1003 7.81002 15.338 7.81002 16.0979 8.56995L18.691 11.1631C19.4196 11.8917 20.6182 11.8917 21.3467 11.1631L23.9398 8.56995C24.6997 7.81002 25.9375 7.81002 26.6974 8.56995L27.9508 9.82345L23.979 13.7955C22.8822 14.8766 21.4486 15.4329 20.0149 15.4329Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1761 27.912L26.2042 23.9399C24.0185 21.7541 24.0185 18.213 26.2042 16.0272L30.1761 12.0552L31.4295 13.3087C32.1894 14.0686 32.1894 15.3064 31.4295 16.0664L28.8364 18.6596C28.1 19.396 28.1 20.5868 28.8364 21.3154L31.4295 23.9086C32.1894 24.6685 32.1894 25.9064 31.4295 26.6663L30.1761 27.912Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_8",
    x1: 12.973,
    y1: 5.4054,
    x2: 68.6487,
    y2: -24.8649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E22440"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovingLogo);
export default __webpack_public_path__ + "static/media/approving_logo.f78c2d7ac26622477aa6753ec19563df.svg";
export { ForwardRef as ReactComponent };